import 'core-js/stable';
import lozad from "lozad";
// import LazyLoad from "vanilla-lazyload";
import tippy from 'tippy.js';
import select2 from "select2/dist/js/select2.full.min";
import {MobileMenu} from "./components/mobile-menu";
import {initMainPageLanding} from "./landings/mainPage";
import {initCalendarPageLanding} from "./landings/calendarPage";
import {initNewsMediaPageLanding} from "./landings/newsMedia";
import {initNewsPageLanding} from "./landings/newsPage";
import {initFansWithDisabilitiesLanding} from "./landings/fansWithDisabilitiesLanding";
import {
    initHashNavigation,
    initTabs,
    updateViewportHeight,
    getHalfViewPortHeight,
    initResizeNewsItems
} from "./components/helpers";
import {initPlayerDetailStats} from "./landings/player-detail";
import {initFullStatistics} from "./landings/full-statistics";
import {initContactsForm} from "./components/contacts-form";
import {initAvailableTicketsLanding} from "./landings/availableTicketsLanding";
import {initYaMap} from "./components/yamap";
import {initStewardLanding} from "./landings/stewardLanding";
import Swiper, {Navigation, Pagination} from "swiper";
import {initRateUs} from "./components/rate-us";
import {initDragFinger} from "./components/drag-finger";
import {initSearchLanding} from "./landings/searchLanding";
import {initGalleryPage} from "./landings/galleryPage";

let currentScroll = $(window).scrollTop();

$( document ).ready(function() {
    // const lazyLoadInstance = new LazyLoad();
    const mobileMenu = new MobileMenu();

    const observer = lozad('.lozad', {
        rootMargin: `${getHalfViewPortHeight()}px 0px`,
    });

    observer.observe();

    headerAnimate();

    $(window).on('scroll', function() {
        headerAnimate();
    });

    updateViewportHeight();

    $('[data-select]').select2({
        theme: 'default',
        minimumResultsForSearch: Infinity,
        dropdownParent: $('[data-select]').parent()
    })

    if ($('#preloader').length) {
    }

    if ($('#main_page_landing').length) {
        initMainPageLanding();
    }

    if ($('#calendar_landing').length) {
        initCalendarPageLanding();
    }

    if ($('#news_media_landing').length) {
        initNewsMediaPageLanding();
    }

    if ($('#wings_tv_list_landing').length) {
        initNewsMediaPageLanding();
    }

    if ($('#good_wings_list_landing').length) {
        initNewsMediaPageLanding();
    }

    if ($('#news_page_landing').length) {
        initNewsPageLanding();
    }

    if ($('#good_wings_news_page_landing').length) {
        initNewsPageLanding();
    }

    if ($('#wings_tv_video_page_landing').length) {
        initNewsPageLanding();
    }

    if ($('#fans_with_disabilities_landing').length) {
        initFansWithDisabilitiesLanding();
    }

    if ($('#available_tickets_landing').length) {
        initAvailableTicketsLanding();
    }

    if ($('#stewards_landing').length) {
        initStewardLanding();
    }

    if ($('#partner_swiper').length) {
        initPartnersSwiper();
    }

    if($('#search_landing').length){
        initSearchLanding();
    }

    initGalleryPage();

    if ($('#page_preloader').length) {
        $(window).ready(() => {
            //если на странице билетов, то не выключаем прелоадер
            if(!$('#available_tickets_landing').length){
                $('#page_preloader').addClass('hide');
            }
        })
    }

    if ($('#contact_form').length) {
        initContactsForm($('#contact_form'));
    }

    if ($('#rate_us').length) {
        initRateUs();
    }

    if($('.finger-block').length){
        initDragFinger();
    }

    initResizeNewsItems();

    $.each($('.socials [data-tooltip]'), function () {
        tippy($(this)[0], {
            arrow: false,
            content: $(this).attr('data-tooltip'),
            theme: 'azureGradient'
        })
    });

    //для профиля
    const $profileDesktop = $('.header-info .profile-link');
    tippy($profileDesktop[0], {
        arrow: false,
        content: $profileDesktop.attr('data-tooltip'),
        theme: 'azureGradient'
    });

    //Открыть и закрыть контент на странице, быстрый приятный скрипт
    $('[data-toggle-btn]').click(function () {
        //не тогглим, если это моб версия на Руководство
        const $managementLanding = $(this).parents('.team-list');
        const isMobile = window.innerWidth < 768;

        if($managementLanding.length && isMobile) return;

        //Условие для аккордеона, чтобы открывалась только одна секция
        if ($(this).parents('[data-toggle-holder]').hasClass('one')) {
            $('[data-toggle-btn]').not($(this)).removeClass('active')
            $('[data-hidden-content]').not($(this).next()).slideUp(300)
        }

        // просто спойлер
        if ($(this).parents('[data-toggle-holder]').hasClass('once')) {
            $(this).addClass('hide')
        }

        $(this).toggleClass('active').next().slideToggle(300)
    })


    $('body').on('click', '.mobile-menu-toggle-button', function () {
        mobileMenu.toggle();
        return false;
    });

    // вкладки
    if ($('[data-tabs-block]').length) {
        $('[data-tabs-block]').each(function() {
            initTabs($(this));
        })
    }

    //раскрытие поиска и его функционал в хедере
    $('[data-header-search]').on('click', function (e){
        e.stopPropagation();
        if(!e.target.classList.length){
            $('.header-input-block').addClass('showed');
        }else if(e.target.classList.length === 1){
            $('.header-input-block').removeClass('showed');
            $('#search_input_header').val('');
        }
    });

    $('[data-clear-search-header-mobile]').on('click', function (e){
        e.stopPropagation();
        if(!e.target.classList.length){
            $('#mobile_menu .header-input-block').addClass('showed');
        }else if(e.target.classList.length === 1){
            $('#mobile_menu .header-input-block').removeClass('showed');
            $('#search_input_mob').val('');
        }
    });

    //показ поиска в моб меню
    $('.arrow-link.search').on('click', e =>{
        e.stopPropagation();
        if(e.target.classList.length === 2){
            $('.arrow-link.search').find('.header-input-block').addClass('showed');
        }else if(e.target.classList.length === 1){
            $('.arrow-link.search').find('.header-input-block').removeClass('showed');
            $('#search_input_header').val('');
        }
    });

    //поиск из хедера
    $('[data-header-input]').on('keydown', function (e){
        if(e.key === 'Enter') {
            window.location.href = window.location.origin + `/search/?search_query=${$(this).val()}`;
        }
    });

    initHashNavigation();

    initPlayerDetailStats()

    initFullStatistics()

    if ($('[data-amplua-list]').length) {
        $('#amplua_select').on('change', () => {
            const value = $('#amplua_select').val()
            const $list = $('[data-amplua-list]')
            if (value === '') {
                $list.find('.team-list').show()
            } else {
                $list.find('.team-list[data-amplua="' + value + '"]').show()
                $list.find('.team-list[data-amplua!="' + value + '"]').hide()
            }

        })
    }

    function headerAnimate() {
        const wHeight = $(window).height();
        const newScroll = $(window).scrollTop();

        if (newScroll > wHeight && newScroll > currentScroll) {
            $('body').addClass('hide-header');
        } else {
            $('body').removeClass('hide-header');
        }

        currentScroll = newScroll;
    }

    function initPartnersSwiper() {
        return new Swiper('#partner_swiper', {
            modules: [Navigation],
            loop: false,
            spaceBetween: 20,
            navigation: {
                nextEl: '.partner-next',
                prevEl: '.partner-prev'
            },
            breakpoints: {
                1281: {
                    slidesPerView: 4,
                    spaceBetween: 120,
                    slidesPerGroup: 4,
                },
                1000: {
                    slidesPerView: 4,
                    spaceBetween: 60,
                    slidesPerGroup: 4,
                },
                760: {
                    slidesPerView: 2,
                    spaceBetween: 120,
                    slidesPerGroup: 2,
                },
                374: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    slidesPerGroup: 2,
                }
            }
        });
    }
});


